(function () {
  const root = document.documentElement;

  function px(n) {
    return `${Math.max(0, Math.round(n))}px`;
  }

  function getVisibleHeightSum(container) {
    if (!container) return 0;
    const bars = container.querySelectorAll('.announcement-bar');
    if (!bars.length) return container.getBoundingClientRect().height;

    let sum = 0;
    bars.forEach((el) => {
      // display:none のものは除外
      const style = window.getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden') return;
      const rect = el.getBoundingClientRect();
      if (rect.height > 0) sum += rect.height;
    });

    // 万一sumが0ならコンテナの高さでフォールバック
    return sum || container.getBoundingClientRect().height;
  }

  function measure() {
    const announcementSection = document.getElementById('shopify-section-announcement-bar');

    // 「固定されている実体」を広めに拾う（header-wrapper / sticky-header / header）
    const headerWrapper =
      document.querySelector('#shopify-section-header .header-wrapper') ||
      document.querySelector('#shopify-section-header sticky-header') ||
      document.querySelector('#shopify-section-header');

    const headerInner =
      document.querySelector('#shopify-section-header .header') ||
      headerWrapper;

    const aH = getVisibleHeightSum(announcementSection);
    const hH = headerInner ? headerInner.getBoundingClientRect().height : 0;

    root.style.setProperty('--dt-announcement-h', px(aH));
    root.style.setProperty('--dt-header-h', px(hH));
  }

  const run = () => {
    measure();
    // 初期描画のズレ吸収
    requestAnimationFrame(() => requestAnimationFrame(measure));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
  window.addEventListener('load', run);
  window.addEventListener('resize', run);

  const ro = new ResizeObserver(run);
  const announcementSection = document.getElementById('shopify-section-announcement-bar');
  const headerSection = document.getElementById('shopify-section-header');
  if (announcementSection) ro.observe(announcementSection);
  if (headerSection) ro.observe(headerSection);
})();
